/**
 * 中文文案字典：界面所有文案只从这里取。
 * 规则（ui-spec §6.1）：无 Emoji、无括号英文、无后端术语；专有名词白名单见规范。
 */
export const zh = {
  app: {
    name: 'Console',
    subtitle: '服务器运维遥控器',
    controlPlane: '控制面',
    controlPlaneConnected: '控制面已连接',
    controlPlaneOffline: '控制面未连接',
    menu: '打开导航',
    skipToContent: '跳到主要内容',
  },

  nav: {
    console: '控制台',
    overview: '概览',
    backToConsole: '← 返回控制台',
    hubs: '节点',
    settings: '设置',
    groupHubs: '节点',
    globalGroup: '全局',
    currentHub: '当前 Hub',
    allHubs: '全部 {count} 个',
    backToHubs: '全部节点',
    hubOverview: '概况',
    wireguardNav: 'WireGuard',
    appsNav: '应用发布',
    wireguard: '内网穿透',
    ops: '主机运维',
    opsNav: '主机运维',
    sites: '站点',
    forwards: '转发',
    certs: '证书',
    apps: '应用',
    hubSettings: '节点设置',
    switchHub: '切换节点',
    openHub: '打开节点 {name}',
  },

  common: {
    dash: '—',
    copy: '复制',
    copied: '已复制',
    cancel: '取消',
    close: '关闭',
    save: '保存',
    saved: '已保存',
    saveAndApply: '保存并生效',
    discard: '放弃修改',
    discardTitle: '放弃修改？',
    discardBody: '关闭后未保存的修改会丢失。',
    discardConfirm: '放弃修改',
    retry: '重试',
    refresh: '刷新',
    delete: '删除',
    more: '更多操作',
    loading: '加载中',
    search: '搜索',
    clear: '清除',
    clearFilter: '清除筛选',
    optional: '（可选）',
    logout: '退出',
    theme: '主题',
    themeLight: '浅色',
    themeDark: '深色',
    themeSystem: '跟随系统',
    download: '下载',
    generate: '生成',
    apply: '应用',
    preview: '预览',
    rollback: '回滚',
    online: '在线',
    offline: '离线',
    unknown: '未知',
    none: '无',
    auto: '自动',
    noChanges: '没有修改',
    searchPalette: '搜索节点、应用或动作',
    paletteEmpty: '没有匹配结果',
    paletteHint: '上下键选择，回车打开',
    backHome: '返回概览',
    yes: '是',
    no: '否',
    seconds: '秒',
    days: '天',
    next: '下一步',
    blockedReason: '请先处理阻断项',
    warningUnaccepted: '请确认全部注意事项',
    errorUnknown: '切换过程中发生未知错误',
    finish: '完成',
    advancedSection: '高级',
  },

  status: {
    online: '在线',
    offline: '离线',
    unknown: '未知',
    unprobed: '未探测',
    reachable: '可达',
    unreachable: '不可达',
    synced: '已同步',
    pending: '下发中',
    queued: '待上线后生效',
    failed: '生效失败',
    running: '运行中',
    done: '已完成',
    error: '失败',
    canceled: '已取消',
    pendingTask: '排队中',
  },

  actions: {
    'hub.create': '添加节点',
    'hub.open': '打开',
    'hub.statusRefresh': '刷新状态',
    'hub.delete': '删除节点',
    'app.save': '保存',
    'app.plan': '预览变更',
    'app.apply': '保存并生效',
    'app.install': '安装',
    'app.uninstall': '卸载',
    'app.rollback': '回滚',
    'peer.create': '添加 Peer',
    'peer.update': '编辑',
    'peer.delete': '删除 Peer',
    'peer.disable': '停用',
    'peer.enable': '启用',
    'peer.exportConfig': '导出配置',
    'peer.rotate': '轮换密钥',
    'peer.publishSite': '发布为站点',
    'peer.confirmRotation': '确认完成',
    'peer.cancelRotation': '取消',
    'wg.interface.update': '接口设置',
    'wg.apply': '应用配置',
    'cert.create': '签发证书',
    'cert.export': '导出证书',
    'cert.delete': '删除证书',
    'cfDns.account.create': '添加凭据',
    'cfDns.account.update': '编辑凭据',
    'cfDns.account.delete': '删除凭据',
    'setting.create': '添加凭据',
    'setting.update': '更新',
    'setting.delete': '删除凭据',
    'site.create': '添加站点',
    'site.update': '编辑',
    'site.delete': '删除站点',
    'site.enable': '启用',
    'site.disable': '停用',
    'site.clear': '清空站点',
    'caddy.service': 'Caddy 服务',
    'caddy.reload': '重载 Caddy',
    'caddy.export': '导出配置',
    'agent.installCommand': '安装 Agent',
    'agent.upgradeCommand': '升级 Agent',
    'agent.remoteUpgrade': '远程升级',
    'agent.uninstallCommand': '卸载 Agent',
    'node.mode.open': '切换模式',
    'node.mode.switch': '确认切换',
    'node.diagnostics.check': '重新检查',
    'node.diagnostics.copyReport': '复制诊断报告',
    'node.diagnostics.openHint': '查看',
    'backup.export': '导出备份',
    'backup.import': '导入备份',
    'forward.create': '添加转发',
    'forward.update': '编辑转发',
    'forward.delete': '删除转发',
    'forward.toggle': '启用/停用',
    'hostOps.processes': '进程',
    'hostOps.firewall': '防火墙',
    'hostOps.sshKeys': 'SSH 公钥',
    'hostOps.svcRestart': '重启',
    'hostOps.svcLogs': '日志',
    'hostOps.status': '获取状态',
    'hostOps.fwApply': '应用防火墙',
    'hostOps.fwConfirm': '确认连接',
    'hostOps.keyAdd': '添加公钥',
    'hostOps.keyRemove': '移除公钥',
    'hostOps.cronAdd': '新增任务',
    'hostOps.cronEdit': '编辑',
    'hostOps.cronToggle': '启停',
    'hostOps.cronRemove': '删除',
    'hostOps.onboard': '接入主机运维',
    'hostOps.probe': '检查连接',
  },

  fields: {
    name: '名称',
    endpoint: '直连地址',
    tunnelEndpoint: '隧道兜底地址',
    liveEndpoint: '实时观测地址',
    note: '说明',
    hostname: '主机名',
    os: '系统',
    kernel: '内核',
    ports: '端口',
    apps: '应用',
    version: '版本',
    configVersion: '配置版本',
    appliedVersion: '已应用版本',
    lastSeen: '最后在线',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    status: '状态',
    mode: '模式',
    route: '当前路由',
    preferredRoute: '首选路由',
    address: '地址',
    domain: '域名',
    domains: '域名',
    issuer: '签发方式',
    expiresAt: '到期',
    source: '来源',
    port: '端口',
    upstream: '上游',
    tls: 'TLS 模式',
    certificate: '证书',
    basicAuth: '基础认证',
    headers: '请求头',
    provider: '服务商',
    credentials: 'DNS 凭据',
    ca: '签发机构',
    days: '有效期',
    keyType: '密钥类型',
    password: '密码',
    username: '用户名',
    value: '凭据值',
    key: '凭据键',
    node: '执行节点',
  },

  secret: {
    storedSet: '已设置',
    replace: '替换',
    cancelReplace: '取消替换',
    onceWarning: '只显示这一次，请立即保存',
    agentNote: '私钥由节点生成，不离开 {node}',
    publicKey: '公钥',
    qr: '二维码',
    download: '下载',
    copy: '复制',
    copied: '已复制',
    codeCopy: '复制',
  },

  help: {
    hubName: '2–24 个字符，小写字母、数字与连字符',
    hubEndpoint: 'Agent 的直连地址，例如 http://<IP>:8880；TLS 用 https://域名:8443',
    hubTunnel: '直连失败时使用的备用地址',
  },

  login: {
    title: '登录 Console',
    subtitle: '登录以管理节点与应用',
    password: '管理员口令',
    submit: '登录',
    pending: '登录中',
    failed: '登录失败，请稍后重试',
    brand: '节点与应用控制台',
  },

  overview: {
    title: '概览',
    greeting: '下午好',
    summaryAllOk: '所有节点都在正常运行',
    summaryAttention: '有 {count} 个节点需要关注',
    summaryEmpty: '添加第一个节点开始使用',
    statHubs: '节点总数',
    statOnline: '在线节点',
    statOffline: '离线节点',
    statUnprobed: '未探测节点',
    statUnprobedHint: '打开页面不探测，去节点列表手动刷新',
    statAttention: '需要处理',
    statAttentionHint: '离线节点与 14 天内到期证书',
    statApps: '应用配置',
    statAppsHint: '按节点分别统计',
    statPeers: '组网 Peer',
    statPeersHint: '共配置 {total} 个 Peer',
    statServices: '站点与转发',
    statServicesHint: '{sites} 个站点 · {forwards} 条转发',
    statCerts: '全局证书库',
    statCertsHint: '{expiring} 张即将到期',
    statCertsOk: '全部在有效期内',
    nodeMatrixTitle: '节点矩阵',
    nodeMatrixSub: '状态来自控制面租约；运行数据请进入节点页或浏览器直连观测',
    manageHubs: '管理节点列表',
    quickLinksTitle: '全局资源入口',
    quickCertsTitle: '全局证书库',
    quickCertsDesc: '跨节点共享 ACME 与自签证书',
    quickSettingsTitle: 'DNS 与全局凭据',
    quickSettingsDesc: '管理自动签发所需的只写凭据',
    quickHubsTitle: '节点接入与管理',
    quickHubsDesc: '添加新节点或轮换通信令牌',
    cpuUsage: 'CPU',
    memUsage: '内存',
    sysLoad: '负载',
    nodeOfflineReason: '控制面直连超时 · {time}前离线',
    certExpiringReason: '证书将于 {days} 天后到期',
    hubs: '节点',
    attention: '需要处理',
    attentionEmpty: '暂无需要处理的事项',
    attentionEmptyHint: '节点或应用出现问题时，会显示在这里',
    recent: '最近操作',
    recentEmpty: '暂无操作记录',
    recentEmptyHint: '创建、修改与删除操作会记录在这里',
    viewAll: '全部',
    noHubs: '还没有节点',
    noHubsHint: '添加节点后，这里会显示运行概况',
    addFirstHub: '添加节点',
    greetingName: '{name}',
    panelVersion: '面板 v{version}',
    hubCardEnter: '进入节点 →',
  },

  hubs: {
    title: '节点',
    summary: '管理所有接入的节点',
    colName: '名称',
    colStatus: '状态',
    colEndpoint: '直连地址',
    colMode: '模式',
    colLastSeen: '最后在线',
    add: '添加节点',
    createTitle: '添加节点',
    createContext: '全局 · 节点',
    createNote: '创建后会生成一次性节点令牌，请立即填入 Agent',
    creating: '创建中',
    tokenTitle: '节点令牌',
    tokenContext: '只显示一次 · 请立即保存',
    tokenWarning: '令牌只显示一次，请复制后填入 Agent 的配置。',
    tokenLabel: '节点令牌',
    createdTitle: '节点已创建',
    createdHint: '按下面三步安装 Agent；安装完成后节点会自动变为在线。',
    installStepTitle: '一键安装命令',
    installStepHint: '复制后在 Hub 上执行；命令会提示粘贴上面的节点令牌，不会把令牌写进 shell 历史。',
    installStepAfter: '执行完成后回到节点页刷新，状态应变为在线；失败时可在节点设置里重新生成命令。',
    installUnavailable: '当前 Worker 没有可用的签名发布包，请在节点设置中生成安装命令。',
    installFailed: '生成安装命令失败，可到节点设置重试。',
    goToNode: '去节点设置',
    createdToast: '节点已添加',
    deleteTitle: '删除节点 {name}？',
    deleteNameLabel: '输入节点名 {name} 以确认',
    deleteBody:
      '节点将从列表移除，节点上的 Peer、站点、转发、证书与应用将不再由面板管理。此操作不可恢复。',
    deleteConfirm: '删除节点',
    emptyTitle: '还没有节点',
    emptyHint: '添加节点后，把安装信息填入 Agent 即可接入',
    searchPlaceholder: '筛选节点',
    noMatch: '没有匹配的节点',
    routeDirect: '直连',
    routeTunnel: '隧道',
    loadError: '无法加载节点列表',
    statusRefresh: '刷新状态',
    statusRefreshFailedTitle: '刷新状态未完成',
    statusRefreshFailed: '刷新状态失败，请重试',
    statusRefreshPartial: '有 {count} 个节点探测失败，状态可能不是最新',
    createFailed: '创建节点失败，请稍后重试',
    deleteFailed: '删除节点失败，请稍后重试',
    missingFields: '请填写名称与直连地址',
    cfDnsEnabledHint: '已启用 Cloudflare DNS 集成：节点创建后将按直连地址 IP 类型自动代建 A/AAAA 记录。',
    cfDnsDisabledHint: '未配置 Cloudflare DNS 凭据：节点域名解析需手工在 Cloudflare 建立 DNS 记录。',
    cfDnsZoneLabel: '域名（可选）',
    cfDnsZonePlaceholder: '选择已启用的 Zone',
    cfDnsSubdomainLabel: '子域名',
    cfDnsSubdomainPlaceholder: '留空则用节点名',
    cfDnsWillCreate: '将在 {name} 建 A 记录；安装命令会自动带上 Caddy 与 --tls-cn=<域名>，证书由 Caddy 自动申请（不走 Agent 自签）。',
    cfDnsRecordsLabel: '已有解析记录',
    cfDnsRecordsPlaceholder: '选择一条已有记录（可选）',
    cfDnsRecordSelectHelp: '只读选用已有记录，不会新建或修改 DNS 记录；主机部分只读，端口可改。',
    cfDnsRecordMissing: '所选解析记录已不可用，请重新选择或手填子域名',
    cfDnsRecordUnavailable: '所选解析记录不可用（同名冲突或已绑定其他节点）',
    cfDnsRecordsLoading: '正在读取该 Zone 的已有解析记录…',
    cfDnsRecordsEmpty: '该 Zone 下还没有 A/AAAA 记录，可手填子域名自动新建。',
    cfDnsRecordsFailedTitle: '读取已有解析记录失败',
    cfDnsRecordsFailedHint: '可继续手填子域名自动新建记录，不影响创建节点。',
    cfDnsRecordUseHint: '将直接使用 {name}（{type} → {content}），不会新建或修改 DNS 记录。',
    cfDnsRecordHostLabel: '直连地址（来自所选记录）',
    cfDnsRecordPortLabel: '端口',
    cfDnsRecordPortInvalid: '端口需为 1–65535',
    cfDnsRecordConflictMulti: '冲突：同名多条记录',
    cfDnsRecordConflictCname: '冲突：同名 CNAME',
    cfDnsRecordBound: '已绑定节点 {name}',
    cfDnsRecordManaged: '面板管理',
    cfDnsRecordUsed: '已使用已有解析记录 {name}（未新建记录）',
    cfDnsReadFailedPermission: '读取失败：Cloudflare Token 权限不足（需要 Zone→DNS→Read 或 Edit）',
    cfDnsReadFailedAuth: '读取失败：Cloudflare Token 无效或已失效',
    cfDnsReadFailedNetwork: '读取失败：无法连接 Cloudflare API',
    cfDnsReadFailedOther: '读取失败：{error}',
    cfDnsDomainField: '域名',
    cfDnsCreateFailedTitle: 'DNS 记录创建失败（节点已创建）',
    cfDnsCreated: '已代建 DNS 记录 {name}',
    cfDnsCreateFailed: 'DNS 代建失败：{error}。不影响节点创建，可稍后处理。',
    cfDnsCreateFailedFallback: '网络或服务异常',
    installOptionsTitle: '安装选项（默认都不带）',
    installWithCaddy: '同时安装 Caddy（反代站点需要）',
    installTls: '启用 Agent 自签 HTTPS（Worker 传输层不信任）',
    installTlsCn: '证书域名（CN）',
    installTlsCnHelp: '域名节点的域名，例如 agent.example.com；证书由 Caddy 自动申请，自签需要另勾 --tls',
    installTlsCnInvalid: '证书域名只允许字母、数字、点、连字符与星号',
    installOptionsHint:
      "域名节点靠 Caddy 自动签 Let's Encrypt，默认不要勾选自签 HTTPS（Worker 传输层不接受自签证书）。不确定就保持默认。",
  },

  ops: {
    title: 'VM 运维',
    cpu: 'CPU',
    usage: '使用率',
    load: '负载',
    mem: '内存',
    swap: 'Swap',
    disk: '磁盘',
    diskInodes: 'inode',
    services: '服务',
    failedUnits: '失败单元',
    listening: '监听端口',
    dns: 'DNS',
    route: '默认路由',
    processes: '占用最高进程',
    rebootRequired: '需要重启',
    uptime: '运行时长',
    collectedAt: '采集时间',
    noData: '节点尚未上报运维状态',
  },

  hostOps: {
    title: '主机运维',
    tab: '运维',
    tabConfig: '配置',
    intro: '按需连接主机执行检查或写操作；Peer 上不安装常驻程序。',
    processes: '进程',
    firewall: '防火墙',
    sshKeys: 'SSH 公钥',
    services: '服务',
    statusAgent: 'Agent 连接',
    uptimeTile: '运行',
    servicesOk: '正常',
    servicesFailed: '{count} 个失败',
    rebootRequiredTile: '需重启',
    restartUnavailable: '服务重启能力尚未开放，待 Agent 支持后启用',
    svc: {
      unit: '服务',
      description: '描述',
      invalidUnit: '服务名不合法（仅允许 *.service）',
      protectedUnit: '该服务受保护，不允许从面板操作',
      restart: '重启',
      restarted: '已重启 {unit}',
      restartTitle: '重启服务 {unit}？',
      restartBody:
        '{unit} 将被 systemctl restart 重启，服务会短暂中断；受保护单元（ssh/systemd/dbus）已被拒绝。执行后自动回读 is-active 状态。',
      logsTitle: '{unit} 日志',
      logsLabel: 'journalctl 尾读 · {unit}',
      noLogs: '（无日志输出）',
    },
    cron: {
      title: '定时任务',
      empty: '尚无 khc 管理的定时任务',
      addTitle: '新增定时任务',
      editTitle: '编辑定时任务',
      stateEnabled: '启用',
      stateDisabled: '停用',
      firstLine: '首条计划',
      formHint: '只管理 /etc/cron.d/khc-* 文件；条目外的系统 cron 只读展示，不会改动。',
      nameHelp: '字母数字/下划线/连字符，≤32 字符；生成文件 /etc/cron.d/khc-<名称>',
      contentLabel: 'cron 内容',
      enabledLabel: '状态',
      invalidName: '名称不合法（字母数字/下划线/连字符，≤32）',
      emptyContent: '内容不能为空（至少一条非注释行）',
      tooManyLines: '内容最多 100 行',
      lineTooLong: '单行超过 512 字符',
      controlChars: '内容含控制字符',
      saved: '已保存',
      removed: '已删除 {name}',
      enabled: '已启用 {name}',
      disabled: '已停用 {name}',
      removeTitle: '删除定时任务 {name}？',
      removeBody: '将删除文件 /etc/cron.d/{file}；该条目对应的计划任务立即停止。',
      remove: '删除',
      unavailable: '目标机没有 {dir}（cron 未安装？），只读展示不可用',
      unavailableShort: 'cron 不可用',
      readOnly: '目标机 /etc/cron.d 不可写（可能运行在只读沙箱），写入操作会失败',
      foreignFiles: '另有 {count} 个面板外 cron 文件，只读展示、不会改动',
    },
    offlineBanner: '节点不可达，以下为缓存状态，执行类操作已禁用',
    liveDisconnectedTitle: '实时观测未连接',
    liveDisconnectedDesc:
      '主机运维数据只来自浏览器直连 Hub；当前没有实时通道，因此不展示运维数据，也不回退控制面快照。',
    liveDisabledTitle: '未启用实时观测',
    liveDisabledDesc: '该节点没有浏览器可直连的观测入口（需绑定域名），运维数据不可用。',
    liveReconnect: '重新连接',
    diagEntry: '诊断 · {count} 项未通过',
    diagEntryIdle: '诊断',
    diagEntryError: '诊断 · 检查失败',
    backToList: '返回列表',
    fwEditTitle: '编辑防火墙',
    processesTitle: '进程',
    firewallTitle: '防火墙',
    keysTitle: 'SSH 公钥',
    refresh: '刷新',
    fetchStatus: '获取状态',
    statusFetching: '获取中',
    neverFetched: '尚未获取',
    dataFrom: '数据来自 {time}',
    justNow: '刚刚',
    cachedFromState: '节点上次上报',
    hostname: '主机名',
    scriptVersion: '脚本版本',
    hostAddress: '地址',
    hostUser: '用户',
    contextSelf: '本机 · {hub}',
    contextPeer: 'Peer · {peer}',
    stepRun: '在 Peer 上执行命令',
    stepCheck: '检查连接并确认指纹',
    hubPublicKey: 'Hub 运维公钥',
    hubKeyFingerprint: '指纹',
    hubKeyFetchFailed: '读取 Hub 公钥失败',
    onboardTitle: '接入主机运维',
    onboardIntro: 'Peer 上不会安装常驻程序，只放一个静态脚本和一把受限公钥；需要时由 Hub 经 WireGuard 发起一次 SSH。',
    onboardNote: '生成一条接入命令，在 Peer 上以 root 执行一次即可。',
    generateCommand: '生成接入命令',
    generating: '生成中',
    installCommand: '一键接入命令',
    uninstallCommand: '卸载命令',
    uninstallHint: '卸载会移除受限公钥、脚本、sudoers 与 khc_fw 防火墙表。',
    checkConnection: '检查连接',
    checking: '检查中',
    fingerprintTitle: '核对主机密钥指纹',
    fingerprintHint: '请与 Peer 上 ssh-keygen -lf /etc/ssh/ssh_host_*_key.pub 的结果核对，确认一致后再保存。',
    algorithm: '算法',
    hostKey: '主机密钥',
    confirmFingerprint: '确认指纹',
    savingConfig: '保存配置并应用',
    saving: '保存中',
    onboardSuccess: '主机运维已接入',
    onboardFailed: '接入失败',
    applyFailed: '应用主机运维配置失败',
    commandMissing: '请先生成接入命令',
    probeFailed: '检查连接失败',
    fingerprintMissing: '没有获取到主机密钥指纹',
    scriptOld: '脚本版本过旧，请重新执行接入命令更新',
    scriptCurrent: '脚本版本正常',
    expectedVersion: '期望版本 {version}',
    updateCommand: '获取更新命令',
    noPriv: '该主机没有管理员权限，仅可查看。',
    shellModifiedTitle: '已临时修改 {user} 的登录 shell',
    shellModifiedDesc: '运维通道需要把该用户的 shell 临时设为 /bin/sh；卸载时会自动恢复为 {shell}。',
    readonly: '只读',
    detailsShow: '查看详情',
    detailsHide: '收起详情',
    statusFailed: '获取状态失败',
    statusEmpty: '尚未获取状态',
    versionFailed: '读取脚本版本失败',
    process: {
      loadFailed: '读取进程失败',
      empty: '没有进程数据',
      pid: 'PID',
      user: '用户',
      cpu: 'CPU',
      mem: '内存',
      start: '启动时间',
      cmd: '命令',
      sortCpu: '按 CPU',
      sortMem: '按内存',
      filterLabel: '进程范围',
      filterBusiness: '只看业务进程',
      filterAll: '显示全部',
      filteredHint: '已隐藏 {count} 个系统进程',
      filterAllHint: '已显示全部进程（其中 {count} 个系统进程）',
      emptyBusiness: '当前没有业务进程',
      detailTitle: '进程 {pid}',
      readOnly: '进程列表只读，面板不提供结束进程操作。',
    },
    firewallRules: {
      loadFailed: '读取防火墙失败',
      empty: '还没有本系统管理的规则',
      systemRules: '本系统管理的规则',
      otherRules: '其他 nft 规则',
      showOther: '展开其他规则',
      hideOther: '收起其他规则',
      otherReadonly: '其他表/链的规则只读展示，不会被修改。',
      allowHint: '这里的“允许”不能放行被系统其他防火墙规则拦截的流量。',
      action: '动作',
      allow: '允许',
      deny: '拒绝',
      proto: '协议',
      port: '端口',
      source: '来源',
      note: '备注',
      locked: '锁定',
      detailTitle: '规则 {id}',
      lockedHint: 'SSH / WireGuard / Hub 管理入口相关规则不可删除。',
      addRule: '添加规则',
      edit: '编辑',
      apply: '应用',
      applying: '应用中',
      applyNote: '保存后会立即应用并进入 60 秒确认期；未确认将自动回滚。',
      draftNote: '保存为草稿；点击「应用」后才下发并进入 60 秒确认期。',
      draftNoteCount: '已修改 {count} 条规则；保存为草稿，应用后才下发。',
      pendingApply: '有未应用的规则修改',
      pendingApplyDesc: '保存的草稿尚未下发到主机。',
      saveDraft: '保存草稿',
      applyNow: '应用',
      waitingTitle: '请在 {seconds} 秒内确认连接，否则自动回滚',
      waitingDesc: '本系统规则已应用。确认当前 SSH / WireGuard / 面板连接仍然正常后点击确认。',
      confirmConnection: '确认连接',
      confirming: '确认中',
      confirmed: '已确认，规则已保留',
      rolledBack: '未在 60 秒内确认，已自动回滚',
      applyFailed: '应用防火墙失败',
      confirmFailed: '确认连接失败',
      conflict: '防火墙已被其他操作修改，请刷新后重试',
      unsupported: '该主机不支持 nftables，防火墙功能不可用',
      invalidPort: '端口格式不正确（示例：22 或 8000-8100）',
      invalidSource: '来源格式不正确（IP 或 CIDR）',
      deleteRule: '删除规则',
      discard: '放弃修改',
      noRulesHint: '还没有自定义规则，添加后会追加到本系统表。',
      waitConfirmFirst: '请先确认连接或等待自动回滚',
      lockedOnly: '锁定规则不可编辑或删除',
      autoTitle: '系统自动放行（主机 iptables）',
      autoHint:
        '由 Agent 为 WireGuard / 端口转发的监听端口自动插入的放行规则，不是用户策略；关闭或卸载对应应用时自动收回。',
      autoApp: '来源应用',
    },
    keys: {
      loadFailed: '读取 SSH 公钥失败',
      empty: '没有 SSH 公钥',
      fingerprint: '指纹',
      type: '类型',
      comment: '备注',
      source: '来源',
      managed: '本系统管理',
      manual: '手工添加',
      add: '添加公钥',
      addTitle: '添加 SSH 公钥',
      publicKey: '公钥',
      publicKeyHelp: '只接受公钥文本；私钥不要粘贴到面板。',
      label: '备注（可选）',
      invalidPublicKey: '公钥格式不正确',
      addFailed: '添加公钥失败',
      added: '公钥已添加',
      remove: '移除',
      removeTitle: '移除公钥 {fingerprint}？',
      removeBody: '只会删除本系统标记块内的公钥，块外手工公钥不受影响。',
      removeFailed: '移除公钥失败',
      removed: '公钥已移除',
      protected: 'Hub 运维公钥不可移除',
      managedOnly: '只能移除此系统管理的公钥',
      lastKey: '这是该用户最后一把可用公钥，不能移除',
      noPriv: '没有权限管理公钥，仅可查看。',
    },
    errors: {
      E_NOT_ONBOARDED: '该主机尚未接入，请先执行接入流程。',
      E_SSH_TIMEOUT: '连接超时，请检查 WireGuard 握手与 Peer 的 sshd。',
      E_SSH_DENIED: '公钥被拒绝，请重新执行接入命令。',
      E_HOSTKEY_CHANGED: '主机密钥已变化，请核对后重新确认指纹。',
      E_SCRIPT_MISSING: '主机上的运维脚本不存在，请重新执行接入命令。',
      E_SCRIPT_OLD: '主机上的运维脚本版本过旧，请执行更新命令。',
      E_NO_PRIV: '该主机没有管理员权限，仅可查看。',
      E_PROTECTED: '该操作被保护规则拦截。',
      E_LOCKOUT: '该规则会导致 SSH / WireGuard / 管理入口失联，已拒绝。',
      E_LAST_KEY: '这是该用户最后一把可用公钥，不能移除。',
      E_CONFLICT: '操作与当前状态冲突，请刷新后重试。',
      E_INVALID: '规则校验失败，请检查协议、端口与来源。',
      E_UNSUPPORTED: '该主机不支持 nftables，防火墙功能不可用。',
      E_BAD_REQUEST: '请求参数不合法。',
      E_UNKNOWN: '操作失败，请稍后重试。',
    },
  },

  channels: {
    control: '控制面',
    live: '实时观测',
    capability: '节点能力',
    managedOnline: '可管理在线',
    liveOnly: '仅观测可达',
    offline: '不可达',
    reachable: '可达',
    unreachable: '不可达',
    readOnly: '只读',
    liveOnlyTitle: '仅观测可达',
    liveOnlyDesc: '浏览器可以直连 Hub 查看实时状态，但控制面无法向 Hub 下发操作；执行类操作暂停，配置保存不受影响。',
    controlFailed: '控制面无法访问 Hub，写操作已禁用。',
    controlUnavailableTitle: '控制面不可达',
    controlUnavailableDesc: '当前无法向 Hub 下发操作；配置编辑仍可保存，但 apply 会失败。',
    retryControl: '重试控制面',
  },

  live: {
    title: '实时观测',
    statusLive: '实时',
    statusConnecting: '连接中',
    statusFallback: '降级 · 控制面快照',
    statusDisabled: '未配置',
    readOnly: '只读',
    endpoint: '观测入口',
    updated: '最近推送',
    hint: '打开页面时直连 Hub，关闭即断开；不可用时使用控制面快照。',
    errorTitle: '实时连接不可用',
    disabledHint: '在节点设置中填写实时观测地址（如 https://hub.example.com）后启用。',
    entryHelp: '浏览器直连 Hub 的 HTTPS 域名；留空表示不启用实时观测',
  },

  hub: {
    quickTitle: '快速入口',
    summary: '节点概况',
    statReachable: '实时状态',
    statRoute: '当前路由',
    statApps: '应用',
    statPorts: '端口',
    statSites: '站点',
    statPeers: 'Peer 在线',
    statLoad: '负载',
    peerDisabledHint: '未启用 · Caddy 网关模式',
    todoTitle: '需要处理',
    todoCertBadge: '证书',
    todoCertDesc: '{days} 天后到期',
    todoFailedUnitBadge: '服务异常',
    todoPeerBadge: 'Peer 离线',
    reachable: '可达',
    unreachable: '不可达',
    domainLabel: '域名',
    certLabel: '证书状态',
    certNoDomain: '未绑定域名',
    certNoSite: '未签发（该域名未建站点，Caddy 不会申请证书）',
    certUnknown: '未知（Agent 未上报）',
    certOk: '已签发（HTTPS 校验通过）',
    certWarn: '未签发或校验失败：{error}',
    certDown: '站点不可达：{error}',
    infoTitle: '节点信息',
    appsTitle: '应用',
    appsEmpty: '还没有应用配置',
    appsEmptyHint: '节点上安装应用后，这里会显示配置与同步状态',
    adaptersTitle: '可用适配器',
    adaptersEmpty: '节点未上报适配器',
    adaptersError: '适配器列表不可用',
    hostTitle: '主机',
    portsTitle: '端口',
    offlineBanner: '节点离线，改动会在上线后生效',
    unreachableBanner: '节点暂时不可达，请检查 Agent 与控制面的连接',
    notFound: '节点不存在',
    noHost: '节点尚未上报主机信息',
    noPorts: '节点尚未上报端口',
    loadError: '无法加载节点',
    stateError: '实时状态不可用',
    appsCount: '{count} 个',
  },

  certs: {
    summary: '全局证书库，可被任意节点的站点引用',
    colName: '名称',
    colDomains: '域名',
    colIssuer: '签发方式',
    colExpiry: '到期',
    colSource: '来源',
    colActions: '',
    issuerAcme: 'ACME',
    issuerSelfsigned: '自签',
    issuerManual: '手动导入',
    issuerUnknown: '未知',
    sourceGlobal: '全局',
    expired: '已过期 {days} 天',
    expiresToday: '今天到期',
    expiresIn: '{days} 天后',
    noExpiry: '未设置',
    expiringHint: '{count} 张证书将在 14 天内到期',
    emptyTitle: '还没有证书',
    emptyHint: '签发或导入证书后，可以在站点中引用',
    add: '签发证书',
    issueTitle: '签发证书',
    importTitle: '导入证书',
    context: '全局 · 证书库',
    modeSelfsigned: '自签',
    modeAcme: 'ACME',
    modeImport: '导入',
    name: '证书名称',
    nameHelp: '便于在站点中选择，节点间共享',
    domainsHelp: '多个域名用逗号分隔，支持通配符',
    daysHelp: '单位天，默认 365',
    keyTypeDefault: '默认',
    keyTypeEcdsa: '椭圆曲线',
    keyTypeRsa: 'RSA',
    nodeHelp: '在哪个节点的 Agent 上执行签发',
    nodeMissing: '没有在线节点，无法签发证书',
    providerHelp: '如 cloudflare、aliyun',
    credentialsHelp: '来自设置中的凭据键，只写不读',
    credentialsMissing: '请先在设置中添加 DNS 凭据',
    manageCredentials: '管理凭据',
    caHelp: "留空使用默认 Let's Encrypt",
    certPem: '证书 PEM',
    keyPem: '私钥 PEM',
    parseCert: '解析证书',
    parsedExpiry: '已解析：{domains}，到期 {time}',
    issueSubmit: '签发',
    importSubmit: '导入',
    issuing: '正在签发',
    issueSuccess: '证书已入库',
    importSuccess: '证书已导入',
    taskTitle: '签发任务',
    taskLogs: '签发日志',
    exportTitle: '导出证书',
    exportConfirmTitle: '导出证书与私钥 {name}？',
    exportConfirmBody: '导出内容包含私钥，仅用于迁移或备份，请确认当前环境安全。',
    exportConfirm: '导出',
    exportSensitive: '导出内容包含私钥，请勿通过不安全渠道发送。',
    certPemLabel: '证书 PEM',
    keyPemLabel: '私钥 PEM',
    downloadCert: '下载证书',
    downloadKey: '下载私钥',
    detailTitle: '证书详情',
    detailContext: '全局 · {name}',
    deleteTitle: '删除证书 {name}？',
    deleteBody: '被站点引用的证书无法删除；删除后不可恢复。',
    deleteReferencedBody: '该证书被 {count} 个站点引用；删除后这些站点会失去证书，配置可能失效。',
    usedBy: '引用站点',
    usedByCount: '被 {count} 个站点引用',
    deleteConfirm: '删除证书',
    deletedToast: '证书已删除',
    createFailed: '证书入库失败',
    actionFailed: '签发失败',
    inspectFailed: '解析失败',
    loadError: '无法加载证书列表',
    summaryCount: '{count} 张证书',
    taskRunningHint: '任务在后台运行，完成后会自动入库并提示',
    nodeOffline: '离线',
    nodeOnline: '在线',
    required: '请填写{field}',
    invalidDomains: '域名格式不正确',
    manualMissingPem: '请粘贴证书与私钥 PEM',
    inspectNeedNode: '需要选择执行节点才能解析证书',
    submitFailed: '提交失败，请稍后重试',
  },

  settings: {
    summary: '全局资源与凭据，只写不读',
    notice: '凭据加密保存，保存后不再显示；修改时需要重新填写完整值。',
    noticeTitle: '凭据只写不读',
    noticeDesc: '加密保存，保存后不再显示；修改时需重新填写完整值。',
    credentialsTitle: 'DNS 凭据',
    colKey: '凭据键',
    colUpdated: '更新时间',
    add: '添加凭据',
    addTitle: '添加凭据',
    updateTitle: '更新凭据',
    context: '全局 · 设置',
    keyHelp: '如 dns.cloudflare，只允许字母、数字与 ._-',
    valueHelp: 'JSON 对象，如 {"token":"..."}',
    valueInvalid: '凭据值需要合法的 JSON 对象',
    keyInvalid: '凭据键格式不正确',
    keyExists: '该凭据键已存在',
    deleteTitle: '删除凭据 {key}？',
    deleteBody: '删除后引用它的证书签发会失败，已有配置不受影响。',
    deleteConfirm: '删除凭据',
    savedToast: '凭据已保存',
    deletedToast: '凭据已删除',
    loadError: '无法加载设置',
    emptyTitle: '还没有凭据',
    emptyHint: '添加 DNS 凭据后，可以签发 ACME 证书',
    update: '更新',
    delete: '删除',
    updated: '更新于 {time}',
  },

  cfDns: {
    title: 'Cloudflare DNS',
    noticeTitle: '最小权限 Token',
    notice:
      '每条凭据用 Cloudflare API Token 识别，权限为 Zone→DNS→Edit 与 Zone→Zone→Read；同一 Token 可见的多个 Zone 在一条凭据内勾选即可，不同账号分开添加。Token 经面板主密钥加密存储、只写不读，不会出现在任何响应或日志里。',
    zoneLabel: 'Zone（域名）',
    zoneHelp: '如 example.com；代建记录形如 <节点名>.<Zone>，删除节点时联动删除。',
    tokenLabel: 'API Token',
    tokenHint: '首次填写后保存；Token 加密存储，保存后不再回显。',
    tokenKeepHint: '已保存 Token（加密存储、不回显）；留空表示保留现有 Token。',
    tokenPlaceholder: '留空表示保留已保存的 Token',
    enableLabel: '启用 DNS 代建',
    enableHint:
      '启用后，添加 endpoint 为 IP 的节点时自动创建 A/AAAA 记录（记录带 khc-server managed 注释）；未启用、或节点 endpoint 为域名时，请在 Cloudflare 手工建记录。',
    statusEnabled: '已启用',
    statusDisabled: '未启用',
    notConfigured: '尚未保存 Token 与 Zone',
    test: '测试连接',
    testOk: '连接正常：Zone {name}（{status}）',
    testOkDesc: 'Token 状态：{tokenStatus}；DNS 写入权限将在首次代建记录时验证。',
    testDisabledHint: '请先保存 Token 与 Zone',
    saveDisabledHint: '启用前需填写 Zone 与 API Token',
    loadError: '无法加载 Cloudflare DNS 设置',
    addTitle: '添加 Cloudflare 凭据',
    editTitle: '编辑 Cloudflare 凭据',
    context: '全局 · 设置 · Cloudflare DNS',
    colName: '名称',
    colAccount: '账号',
    colZones: '已启用 Zone',
    colToken: 'Token',
    tokenOk: '已配置',
    tokenMissing: '缺失',
    nameLabel: '凭据名称',
    nameHelp: '便于区分，如「主账号」「备用账号」；同一账号多 Zone 用一条凭据即可。',
    nameRequired: '请填写凭据名称',
    tokenRequired: '请填写 API Token',
    tokenReadonly: '已保存（加密存储，不回显）',
    zoneListLabel: '启用的 Zone',
    zoneListHelp: '只勾选要给节点用的 Zone；添加节点时从这里选。',
    zoneListEmpty: '该 Token 下没有可用 Zone',
    refresh: '重新拉取 Zone',
    refreshOk: 'Zone 列表已更新',
    add: '验证并添加',
    createHint: '添加后会拉取 Token 下的全部 Zone（默认全选）；可取消不需要的 Zone 再保存。',
    createdToast: '凭据已添加',
    deletedToast: '凭据已删除',
    emptyTitle: '还没有 Cloudflare 凭据',
    emptyHint: '添加一条凭据后，就能在添加节点时直接选域名并代建解析。',
    deleteTitle: '删除凭据「{name}」？',
    deleteBody:
      '只删除面板保存的 Token 与 Zone 勾选，不会改动 Cloudflare 上已存在的 DNS 记录；已托管记录在删除节点时仍会尝试清理。',
    deleteConfirm: '删除凭据',
  },

  sites: {
    summary: '管理节点上的 Caddy 站点',
    summaryCount: '{count} 个站点',
    offlineTitle: '节点不可达',
    offlineDesc: '暂时无法应用配置；已保存的改动会在上线后生效。',
    colDomain: '域名',
    colKind: '类型',
    colPort: '端口',
    colTarget: '上游或根目录',
    colTls: 'TLS 模式',
    colHealth: '健康状态',
    colSync: '同步',
    syncPending: '待应用',
    colActions: '',
    kindProxy: '反代',
    kindStatic: '静态',
    kindRedirect: '跳转',
    tlsAuto: '自动签发',
    tlsManual: '手动证书',
    tlsInternal: '内部证书',
    tlsOff: '关闭 TLS',
    healthOk: '正常',
    healthWarn: '告警',
    healthDown: '不可用',
    healthUnknown: '未知',
    statusDisabled: '已停用',
    statusValidateFailed: '校验失败',
    certNone: '不引用',
    certManage: '管理证书库',
    certMismatch: '所选证书域名与站点域名不匹配，Caddy 校验可能失败',
    detailsTitle: '校验错误详情',
    emptyTitle: '还没有站点',
    emptyHint: '添加站点后保存并生效，Caddy 会自动加载',
    add: '添加站点',
    addTitle: '添加站点',
    editTitle: '编辑站点',
    context: '节点 · {hub}',
    name: '站点名称',
    nameHelp: '节点内唯一，留空使用域名',
    groupBasic: '基础',
    groupProxy: '反代',
    groupStatic: '静态文件',
    groupRedirect: '跳转',
    groupTls: 'TLS 与证书',
    groupSecurity: '认证与安全',
    groupLog: '日志',
    groupObserve: '观测入口',
    segmentSites: '站点',
    segmentApps: '扩展应用',
    segmentCerts: '证书',
    certsManage: '管理全局证书库 →',
    certsEmptyTitle: '本节点没有关联证书',
    certsEmptyHint: '在全局设置签发或导入证书后，可在站点 TLS 中引用。',
    kind: '类型',
    kindHelp: '反代转发到上游；静态直接提供文件；跳转重定向到目标',
    domainsHelp: '多个域名用逗号分隔',
    domainHelp: '客户端访问的域名',
    listenPort: '对外端口',
    listenPortHelp: '对外暴露的端口（Caddy 监听），常用 443、8443、80',
    enabled: '启用',
    upstreams: '上游地址',
    domainPick: '从已有域名选择',
    domainPickHelp: '来自已配置证书的域名；也可以直接在下方输入新域名',
    domainPickCustom: '自定义输入',
    target: '目标来源',
    targetHelp: '选择 Peer 或本机服务；选择后会填入上游地址',
    targetLocal: '本机（127.0.0.1）',
    targetCustom: '自定义上游',
    targetPort: '目标端口',
    targetPortHelp: 'Peer 或本机上实际提供服务的端口',
    targetSource: '目标来源',
    targetSourceHelp: '从已配置的 Peer 选择目标，或选本机；自定义时手动填地址',
    listenHost: '监听地址',
    listenHostHelp: '对外监听的本地地址，默认 0.0.0.0；仅本机可访问用 127.0.0.1',
    invalidListenHost: '监听地址必须是 IPv4/IPv6 地址',
    upstreamsHelp: '多个上游用逗号分隔，如 10.99.0.2:8080, 127.0.0.1:3000',
    lbPolicy: '负载均衡',
    lbRoundRobin: '轮询',
    lbRandom: '随机',
    lbLeastConn: '最少连接',
    lbIpHash: '按 IP 哈希',
    healthUri: '健康检查路径',
    healthUriHelp: '如 /health，留空不主动探测',
    pathRoutes: '路径路由',
    pathRoutesHelp: '按路径前缀转发到不同上游，路径如 /api/*',
    pathPlaceholder: '路径',
    upstreamPlaceholder: '上游',
    addRoute: '添加路径',
    removeRow: '删除',
    root: '根目录',
    rootHelp: '静态文件目录，如 /var/www/blog',
    browse: '允许浏览目录',
    spa: '单页应用模式',
    index: '默认首页',
    indexHelp: '如 index.html',
    tryFiles: '尝试文件',
    tryFilesHelp: '多个用逗号分隔，如 {path}, /index.html',
    redirectTo: '跳转目标',
    redirectToHelp: '如 https://example.com{uri}',
    redirectCode: '跳转状态码',
    tlsHelp: '自动签发使用 Caddy ACME；手动引用证书库；内部证书仅本机信任；关闭只监听 80',
    cert: '证书',
    certHelp: '手动模式必选，来自全局证书库',
    certMissing: '手动模式需要选择有效证书',
    forceTls13: '仅允许 TLS 1.3',
    basicAuth: '基础认证',
    basicAuthHelp: '用户名与密码，保存前在节点上生成哈希',
    basicAuthSet: '已设置密码，留空表示保持不变',
    username: '用户名',
    password: '密码',
    passwordKeep: '留空表示保持原密码',
    usernameRequired: '基础认证需要填写用户名',
    passwordRequired: '基础认证需要填写密码',
    passwordHashFailed: '密码哈希生成失败',
    headers: '请求头',
    headersHelp: '逐条添加响应头，键值都必填',
    headerKey: '请求头名称',
    headerValue: '请求头值',
    addHeader: '添加请求头',
    headersInvalid: '请求头需要填写完整的名称与值',
    hsts: '启用 HSTS',
    securityHeaders: '启用安全响应头',
    compression: '启用压缩',
    maxBodyBytes: '最大请求体',
    maxBodyBytesHelp: '单位字节，留空不限制',
    allowedIps: '允许的地址',
    deniedIps: '拒绝的地址',
    ipListHelp: '多个用逗号分隔，支持 IP 或 CIDR',
    invalidIp: '地址格式不正确',
    invalidMaxBody: '最大请求体需要是非负整数',
    logEnabled: '启用访问日志',
    logPath: '日志路径',
    logPathHelp: '如 /var/log/caddy/blog.log，留空由 Caddy 决定',
    liveGateway: '启用观测入口',
    liveGatewayHelp: '站点内挂载 /_live/* 反向代理到节点的实时观测服务',
    savedToast: '站点已保存',
    appliedToast: '站点已保存并生效',
    createFailed: '保存站点失败',
    actionFailed: '操作失败',
    applyFailed: '应用站点配置失败',
    validateFailed: '校验失败',
    deleteTitle: '删除站点 {name}？',
    deleteBody: '站点会立即下线，配置从节点移除。此操作不可恢复。',
    deleteConfirm: '删除站点',
    deletedToast: '站点已删除 {name}',
    disabledToast: '已停用 {name}',
    enabledToast: '已启用 {name}',
    applyConfirmTitle: '应用站点配置？',
    applyConfirmBody: 'Caddy 会先校验再平滑重载，连接可能短暂中断。',
    offlineWriteReason: '节点不可达，暂时不能执行该操作',
    unapplied: '有未应用的改动',
    unappliedDesc: '配置已保存到仓库，应用后才会下发到节点。',
    loadError: '无法加载站点配置',
    hashFailed: '密码哈希失败',
    invalidDomain: '域名格式不正确',
    invalidDomains: '请填写至少一个合法域名',
    invalidUpstream: '上游地址格式不正确',
    invalidUpstreams: '请填写至少一个合法上游地址',
    invalidName: '站点名称格式不正确',
    duplicateName: '站点名称已存在',
    duplicateAddress: '域名与端口已被其他站点占用',
    invalidPort: '端口需要 1–65535',
    exportJson: '导出 JSON',
    importJson: '导入 JSON',
    exportSuccess: '站点 JSON 已导出',
    exportEmpty: '当前没有可导出的站点',
    exportFailed: '导出站点失败',
    importFailed: '导入站点失败',
    importFileTooLarge: '站点文件超过 2 MB 上限',
    importPreviewTitle: '导入站点预览',
    importPreviewDesc: '确认后只保存配置，不会自动应用；请稍后手动应用。',
    importStatus: '处理方式',
    importReason: '说明',
    importStatusNew: '新增',
    importStatusOverwrite: '覆盖',
    importStatusConflict: '冲突',
    importConfirm: '确认导入',
    importSaving: '保存导入配置',
    importSuccess: '站点已导入并保存，需手动应用',
    importConflictHint: '存在冲突项，请修正 JSON 后重新导入',
    importErrorsTitle: '文件校验错误',
    importNoRows: '文件中没有可导入的站点',
    importCounts: '共 {total} 项，新增 {created}，覆盖 {updated}，冲突 {conflicts}',
    invalidPath: '路径需要以 / 开头',
    invalidRedirect: '跳转目标格式不正确',
    redirectRequired: '跳转类型需要填写跳转目标',
    rootRequired: '静态类型需要填写根目录',
    upstreamRequired: '反代类型需要填写上游地址',
    adapterMissing: '节点未上报 Caddy 站点适配器',
    adapterMissingDesc: '请确认节点上的 Agent 已安装 Caddy。',
    notInstalled: '节点上还没有 Caddy 站点配置',
    notInstalledDesc: '保存并生效后会创建配置并重载 Caddy。',
    clear: '清空站点',
    clearTitle: '清空所有站点？',
    clearBody: '将删除全部站点并立即生效，所有站点会下线。此操作不可恢复。',
    clearConfirm: '清空站点',
    clearedToast: '站点已清空',
    clearFailed: '清空站点失败',
    service: 'Caddy 服务',
    serviceTitle: 'Caddy 服务',
    serviceNormal: '服务正常',
    serviceContext: '节点 · {hub}',
    serviceStatusTitle: '服务状态',
    serviceVersion: '版本',
    serviceActive: '运行状态',
    serviceRunning: '运行中',
    serviceStopped: '未运行',
    serviceValidate: '配置校验',
    serviceValidateOk: '通过',
    serviceValidateFailed: '未通过',
    serviceLastReload: '最近重载',
    serviceNever: '尚未重载',
    serviceUnit: '服务名',
    serviceCaddyfile: 'Caddyfile',
    serviceReload: '重载 Caddy',
    serviceReloading: '重载中',
    serviceReloadConfirmTitle: '重载 Caddy？',
    serviceReloadConfirmBody: '会先校验配置，通过后平滑重载；校验失败不会改动现有配置。',
    serviceReloadSuccess: 'Caddy 已重载',
    serviceReloadFailed: '重载失败',
    serviceValidateAction: '重新校验',
    serviceValidateSuccess: '校验通过',
    serviceValidateFailedToast: '校验未通过',
    serviceExport: '导出配置',
    serviceExportTitle: '导出 Caddy 配置',
    serviceExportSensitive: '配置包含站点域名与路径，请谨慎分享。',
    serviceConfigEmpty: '没有可导出的配置',
    serviceCaddyfileLabel: '主 Caddyfile',
    serviceSnippetLabel: '托管片段 {index}',
    serviceDownload: '下载配置',
    serviceBack: '返回状态',
    serviceRetry: '重试',
    serviceLoadError: '无法读取 Caddy 服务状态',
    serviceDetails: '服务错误详情',
  },
  forwards: {
    summary: '管理节点上的端口转发',
    summaryCount: '{count} 条转发',
    securityWarning: '转发端口没有应用层鉴权，请只暴露必要的服务。',
    colName: '名称',
    colProtocol: '协议',
    colListen: '监听端口',
    colTarget: '目标',
    colStatus: '状态',
    colNote: '备注',
    protocolTcp: 'TCP',
    protocolUdp: 'UDP',
    statusActive: '生效',
    statusPending: '待应用',
    statusFailed: '失败',
    statusDisabled: '停用',
    add: '添加转发',
    addTitle: '添加转发',
    editTitle: '编辑转发',
    context: '节点 · {hub}',
    name: '名称',
    nameHelp: '节点内唯一，决定 systemd unit 名称',
    protocol: '协议',
    protocolHelp: 'TCP 或 UDP',
    listenPort: '对外端口',
    listenPortHelp: '节点上对外监听的端口',
    targetHost: '目标主机',
    targetHostHelp: '域名或 IP，如 10.99.0.2',
    targetPort: '目标端口',
    targetPortHelp: 'Peer 或本机上实际提供服务的端口',
    targetSource: '目标来源',
    targetSourceHelp: '从已配置的 Peer 选择目标，或选本机；自定义时手动填地址',
    listenHost: '监听地址',
    listenHostHelp: '对外监听的本地地址，默认 0.0.0.0；仅本机可访问用 127.0.0.1',
    invalidListenHost: '监听地址必须是 IPv4/IPv6 地址',
    enabled: '启用',
    enabledHelp: '停用后不生成 unit、不占用端口',
    note: '备注',
    noteHelp: '可选，仅用于说明用途',
    emptyTitle: '还没有转发规则',
    emptyHint: '添加规则并保存生效后，节点会启动 socat 转发。',
    savedToast: '转发规则已保存',
    appliedToast: '转发规则已保存并生效',
    deletedToast: '转发规则已删除 {name}',
    enabledToast: '已启用 {name}',
    disabledToast: '已停用 {name}',
    createFailed: '保存转发规则失败',
    applyFailed: '应用转发配置失败',
    loadError: '无法加载转发配置',
    invalidName: '名称格式不正确（字母/数字/下划线/中划线，1–32 位）',
    duplicateName: '名称已被其他规则使用',
    invalidListenPort: '监听端口需要 1–65535',
    invalidTargetPort: '目标端口需要 1–65535',
    invalidTargetHost: '目标主机格式不正确',
    duplicateListen: '协议与监听端口已被其他规则占用',
    deleteTitle: '删除转发 {name}？',
    deleteBody: '删除后会停止该转发并释放监听端口。',
    deleteConfirm: '删除转发',
    applyConfirmTitle: '应用转发配置？',
    applyConfirmBody: '会先校验再应用；失败时旧规则保持不变。',
    offlineTitle: '节点不可达',
    offlineDesc: '暂时无法应用配置；已保存的改动会在上线后生效。',
    offlineWriteReason: '节点不可达，暂时不能执行该操作',
    unapplied: '有未应用的改动',
    unappliedDesc: '配置已保存到仓库，应用后才会下发到节点。',
    adapterMissing: '节点未上报端口转发适配器',
    adapterMissingDesc: '请确认节点上的 Agent 已安装 socat 与转发适配器。',
    notInstalled: '转发服务尚未就绪',
    notInstalledDesc: '保存并生效后会创建配置并启动转发；若 socat 未安装，请先在节点上安装。',
    statusError: '转发服务状态异常',
    detailsTitle: '应用错误详情',
    toggle: '启用/停用',
  },

  nodeSettings: {
    summary: 'Agent 接入、节点模式、备份恢复与危险操作',
    segmentLabel: '节点设置分区',
    segmentAgent: 'Agent 与接入',
    segmentMode: '节点模式',
    segmentBackup: '备份与恢复',
    segmentDanger: '危险区',
    importEntry: '导入备份…',
    done: '完成',
    dangerHint: '如需重新管理，需重新添加节点并安装 Agent。',
    deleted: '节点已删除',
    cleanupLabel: '同时清理节点本机服务残留',
    cleanupHint:
      '经主机运维通道清理本机的 WG 接口与配置、Caddy khc.d 配置、转发 unit 与 /opt/khc、/etc/khc 残留；不含 khc-agent 自身（卸载请用 Agent 卡片的卸载命令）。清理失败或仍有残留时会阻止删除，可取消勾选改为仅删除面板记录。',
    cleanupUnavailable: '未接入主机运维通道（host-ops 未安装），无法远程清理；直接删除面板记录即可。',
    cleanupRemaining: '清理未完成，已阻止删除。残留项：{items}',
    dnsDeleteLabel: '同时删除面板代建的 DNS 记录',
    dnsDeleteHint:
      '删除节点时联动清理 Cloudflare 上由面板代建的 A/AAAA 记录；删除失败会列出残留项，不影响节点删除本身。',
    dnsDeleteErrors: '节点已删除，但部分 DNS 记录删除失败：{items}',
    dnsDeleteFailed: 'DNS 记录删除请求失败',
  },

  backup: {
    summary: '导出/导入节点应用配置',
    noticeTitle: '备份范围',
    notice: '备份包含节点公开信息与应用配置，不含节点 token、证书私钥或 DNS 凭据；恢复到新节点后需重生成接口密钥，并重新下发 peer 客户端配置。',
    importNotice: '导入只写入应用配置，不会自动 apply；请逐项打开应用执行 plan/apply。恢复到新节点后需重生成接口密钥并重新下发 peer 配置。',
    exportTitle: '导出备份',
    exportDesc: '导出当前节点的应用配置为 JSON 文件。',
    export: '导出备份',
    exporting: '导出中',
    exportFailed: '导出备份失败',
    exportFilename: '文件名',
    importTitle: '导入备份',
    importDesc: '选择备份 JSON → 预览应用 → 确认导入。',
    chooseFile: '选择备份文件',
    replaceFile: '重新选择',
    clearFile: '清除',
    parsing: '解析中',
    fileLabel: '文件',
    fileSize: '大小',
    previewTitle: '导入预览',
    previewEmpty: '尚未选择备份文件',
    previewEmptyHint: '选择 .json 备份文件后在这里预览应用列表。',
    previewNode: '来源节点',
    previewExportedAt: '导出时间',
    colApp: '应用',
    colSchemaVersion: '配置版本',
    colExisting: '当前节点',
    existing: '覆盖',
    newApp: '新增',
    import: '确认导入',
    importing: '导入中',
    importConfirmTitle: '确认导入备份？',
    importConfirmBody: '导入会覆盖节点上同名应用配置并生成新 rev，不会自动 apply。',
    importFailed: '导入备份失败',
    duplicateTitle: '该备份刚刚已导入',
    duplicateDesc: '重复导入会再次生成新的 rev，请确认是否需要覆盖。',
    overwriteTitle: '将覆盖 {count} 个已有应用配置',
    overwriteDesc: '同名应用会生成新的 rev，导入后请逐项 plan/apply。',
    resultTitle: '导入结果',
    resultHint: '配置已导入，需逐项应用',
    colRev: '新 rev',
    invalidFile: '备份文件无效',
  },

  diagnostics: {
    title: '诊断与操作',
    summaryOk: '未发现需要处理的问题',
    summaryIssues: '{count} 项需要处理',
    summaryWarn: '{count} 项需要关注',
    summaryInfo: '{count} 项提示',
    lastChecked: '最近检查 {time}',
    neverChecked: '尚未检查',
    recheck: '重新检查',
    checking: '正在检查',
    truncated: '检查结果已截断，仅显示部分项目',
    stale: '数据来自 {minutes} 分钟前',
    offlineTitle: '节点离线',
    offlineHint: '显示上次检查结果，恢复连接后可重新检查',
    loadError: '无法完成检查',
    loadErrorHint: '控制面暂时无法获取诊断结果，请重试',
    view: '查看',
    drawerContext: '节点 {hub} · 诊断详情',
    status: '状态',
    rootCause: '根因',
    impact: '影响',
    causes: '可能原因',
    steps: '检查步骤',
    readonlyHint: '以下命令只读，复制到节点上执行',
    evidence: '技术信息',
    relatedLog: '相关日志',
    fixes: '可以这样处理',
    copyReport: '复制诊断报告',
    reportCopied: '已复制诊断报告',
    reportTitle: '诊断报告',
    fixRunning: '处理中',
    fixFailed: '处理失败，问题仍在',
    fixDone: '已处理，正在重新检查',
    disabledOffline: '节点离线，无法执行',
    disabledBusy: '节点正在执行其它任务',
    noFix: '这类问题需要在节点上人工处理',
    manual: '人工处理',
    configFix: '去配置',
    confirmTitle: '执行「{label}」？',
    confirmBody: '该操作可能短暂中断服务，失败会自动回滚；请确认节点可达且没有其它任务在执行。',
    fixSuccess: '处理成功，正在重新检查',
    fixError: '处理失败',
    reportGenerated: '生成时间 {time}',
    commandLabel: '只读命令',
    autoChecked: '诊断已自动检查',
    unknownHint: '该应用问题由适配器上报，按说明与技术信息处理',
    noEvidence: '没有可展示的技术信息',
    checkItem: '检查项',
    description: '说明',
    operation: '操作',
    severityInfo: '提示',
    severityWarn: '需关注',
    severityError: '需处理',
    countError: '{count} 项错误',
    countWarn: '{count} 项关注',
    countInfo: '{count} 项提示',
    noIssuesHint: '连接、Agent 与各应用状态都没有发现需要处理的问题。',
    loadFailed: '诊断加载失败',
  },

  mode: {
    title: '节点模式',
    switchToWg: '切换到组网节点',
    switchToCaddy: '切换到 Caddy 网关',
    wgTitle: '组网节点',
    wgDesc: 'WireGuard 负责组网，Caddy 站点与证书照常运行。',
    caddyTitle: 'Caddy 网关',
    caddyDesc: '仅运行 Caddy 站点与证书，WireGuard 与端口转发停用。',
    badgeWg: '组网节点',
    badgeCaddy: 'Caddy 网关',
    badgeUnknown: '未确认',
    loadError: '无法读取节点模式',
    offline: '节点离线',
    offlineHint: '模式信息可能不是最新，恢复连接后可重试',
    disabledOffline: '节点离线，无法切换',
    unknownHint: 'Agent 不可达或还没有网络配置，暂时无法切换模式。',
    blockers: '阻断项',
    blockerFix: '去处理',
    impactTitle: '影响摘要',
    impactAck: '我已了解以上影响',
    blockedReason: '请先处理阻断项',
    impactUnaccepted: '请先确认影响摘要',
    errorUnknown: '切换过程中发生未知错误',
    confirmSwitch: '确认切换',
    switchBusy: '切换中…',
    switchSuccess: '已切换到{label}',
    switchFailed: '切换失败',
    failedCode: '错误码 {code}',
    retry: '重试',
    retryHint: '可以重试；失败时保留原配置，不会删除密钥或证书。',
    viewDiagnostics: '查看诊断',
    modeNow: '当前为{label}',
    checkedAt: '预检时间 {time}',
    wireguardDisabledTitle: '当前是 Caddy 网关模式，WireGuard 已停用',
    wireguardDisabledDesc: '如需使用 WireGuard 组网，请到节点设置切换模式。',
    wireguardReadOnly: 'Caddy 网关模式下 WireGuard 只读',
    forwardDisabledTitle: '端口转发依赖 WireGuard，当前不可用',
    forwardDisabledDesc: '当前是 Caddy 网关模式；如需转发，请先切换到组网节点。',
    goSettings: '去节点设置',
    drawerContext: '节点 {hub} · 模式切换',
  },
  agent: {
    title: 'Agent',
    tokenLabel: '节点 token（安装命令会提示粘贴）',
    version: '版本',
    runMode: '运行模式',
    lastSeen: '最后在线',
    notReported: '尚未上报',
    unknown: '未知',
    loadError: '无法读取 Agent 状态',
    offline: '节点离线',
    offlineHint: '离线时仍可生成命令，但需恢复连接后执行',
    disabledOffline: '节点离线，无法生成命令',
    loading: '读取 Agent 状态',
    drawerContext: '节点 {hub} · Agent 命令',
    installTitle: '安装 Agent',
    upgradeTitle: '升级 Agent',
    uninstallTitle: '卸载 Agent',
    deleteWithScript: '同时生成卸载 Agent 脚本',
    deleteWithScriptHint: '无需填写安装包地址；删除前自动生成，删除后仍可复制/下载。',
    uninstallScriptTitle: '卸载 Agent · {name}',
    uninstallScriptContext: '节点记录已删除 · 卸载脚本',
    scriptAfterDeleteTitle: '节点记录已删除',
    scriptAfterDeleteHint: '在旧主机的终端执行以下命令卸载 Agent；脚本自包含，不需要节点令牌。',
    downloadScript: '下载脚本',
    modeLabel: '运行模式',
    modeSystem: '系统模式',
    modeUser: '用户模式',
    modeHelp: '系统模式以 root 运行并注册 systemd；用户模式不 sudo。',
    packageUrl: '安装包地址',
    packageUrlHelp: 'https 地址，指向 Agent 发布包，不超过 2048 个字符',
    sha256: 'sha256',
    sha256Help: '安装包校验值，64 位十六进制',
    purge: '同时删除配置与数据',
    purgeHelp: '卸载时删除 /etc/khc-agent 与数据目录；谨慎使用。',
    generate: '生成命令',
    generating: '生成中',
    regenerate: '重新生成',
    command: '安装命令',
    commandUninstall: '卸载命令',
    commandUpgrade: '升级命令',
    emptyCommand: '填写参数后生成命令，命令只在本机终端执行。',
    tokenWarning: '命令不包含节点令牌；执行时会从终端读取，请勿把令牌发到群聊或截图。',
    copyCommand: '复制命令',
    copied: '命令已复制',
    generateFailed: '生成命令失败',
    validationFailed: '请检查填写内容',
    installationHint: '命令由你在目标节点上粘贴执行，面板不会远程执行。',
    agentModeWg: '组网节点',
    agentModeCaddy: 'Caddy 网关',
    agentModeUnknown: '未上报',
    install: '安装',
    upgrade: '升级',
    uninstall: '卸载',
    noAgentHint: '节点还没有上报 Agent 信息，可先生成安装命令。',
    remoteUpgrade: '远程升级',
    remoteUpgradeTitle: '远程升级 Agent',
    remoteUpgradeLatest: '最新版本',
    remoteUpgradePackage: '包地址',
    remoteUpgradeSha: 'sha256',
    remoteUpgradeBody:
      'Agent 将在后台拉取发布清单中的安装包、校验 sha256 后自动重启完成升级（拉取式，不推送任何文件）。期间与该节点的连接会短暂中断，通常 1 分钟内恢复。',
    remoteUpgradeConfirm: '下发升级',
    remoteUpgradeNameLabel: '输入版本号 {version} 以确认',
    remoteUpgradeDispatched:
      '升级指令已下发：Agent 正在拉取并自重启，连接会短暂中断；请稍后刷新页面查看版本。',
    remoteUpgradeNoRelease: '发布清单为空，无法远程升级；请先发布 Agent 包。',
    remoteUpgradeFailed: '远程升级下发失败',
  },

  wireguard: {
    summary: '管理 Peer 接入与密钥',
    count: '{count} 个 Peer',
    colName: '名称',
    colAddress: '地址',
    colStatus: '状态',
    colHandshake: '最新握手',
    colTraffic: '流量',
    traffic: '收 {rx} · 发 {tx}',
    statusOnline: '在线',
    statusOffline: '离线',
    statusDisabled: '已停用',
    statusUnknown: '未知',
    statusPendingApply: '待生效',
    emptyTitle: '还没有 Peer',
    emptyHint: '添加 Peer 后导出配置，导入设备即可接入',
    add: '添加 Peer',
    addTitle: '添加 Peer',
    editTitle: '编辑 Peer',
    peerContext: '节点 · {hub}',
    nameHelp: '节点内唯一，1–32 个字符',
    allowedIps: '允许的地址',
    allowedIpsHelp: 'Peer 可访问的网段，多个用逗号分隔',
    keepalive: '保活间隔',
    keepaliveHelp: '单位秒，0 表示不发送',
    publicKey: '公钥',
    publicKeyHelp: '留空由节点生成；设备自持私钥时填写',
    enabled: '启用',
    enabledHelp: '停用后该 Peer 立即断开',
    duplicateName: '名称已存在',
    invalidName: '名称只能包含字母、数字与 _ . @ -',
    invalidAddress: '地址格式应为 CIDR，如 10.99.0.2/32',
    invalidPublicKey: '公钥格式不正确，需要 44 个字符',
    invalidKeepalive: '保活间隔需要 0–65535',
    privateKeyNote: '私钥只在导出或换钥时显示，不写入列表',
    interfaceTitle: '接口设置',
    interfaceContext: '节点 · {hub}',
    interfaceSection: '接口',
    interfaceHint: '接口级修改会重启 WireGuard 服务，Peer 会短暂断开',
    ifaceName: '接口名称',
    address: '接口地址',
    listenPort: '监听端口',
    mtu: 'MTU',
    extIface: '出口网卡',
    publicEndpoint: '公网地址',
    ifaceAddressHelp: 'CIDR 格式，如 10.99.0.1/24',
    publicEndpointHelp: '填写 IP:端口 或 域名:端口，Peer 连接使用',
    invalidIfaceName: '接口名称格式不正确',
    invalidIfaceAddress: '接口地址需要 CIDR 格式',
    invalidPort: '端口需要 1–65535',
    invalidMtu: 'MTU 需要 576–9000',
    invalidEndpoint: '公网地址需要 host:port',
    interfacePublicKey: '接口公钥',
    privateKeyAgent: '私钥由节点生成并保管',
    notInstalledTitle: '节点上尚未安装 WireGuard',
    notInstalledDesc: '保存并生效后会创建接口并启动服务。',
    adapterMissing: '节点未上报 WireGuard 适配器',
    adapterMissingDesc: '请确认节点上的 Agent 已安装 WireGuard 工具。',
    offlineTitle: '节点不可达',
    offlineDesc: '暂时无法应用配置或导出；已保存的改动会在上线后生效。',
    offlineWriteReason: '节点不可达，暂时不能执行该操作',
    unapplied: '有未应用的改动',
    unappliedDesc: '配置已保存到仓库，应用后才会下发到节点。',
    applyNow: '应用配置',
    savedToast: '已保存到仓库',
    appliedToast: '已保存并生效',
    saveFailed: '保存失败',
    actionFailed: '操作失败',
    applyConfirmTitle: '应用配置？',
    applyConfirmBody: '接口级修改会重启 WireGuard 服务，Peer 会短暂断开。',
    applyFailed: '应用失败',
    exportTitle: '导出 Peer 配置',
    exportContext: 'Peer · {name}',
    exportSensitive: '配置包含 Peer 私钥，请勿通过不安全渠道发送。',
    exportHint: '导入设备后即可连接；面板可重复导出。',
    exportFailed: '导出失败',
    exportNeedApply: '节点还没有生效的配置，请先保存并生效',
    exportStagedTitle: '该 Peer 尚未下发到节点',
    exportStagedDesc:
      '当前为暂存态：配置只保存在面板数据库，节点上还没有这个 Peer（导出需要节点侧的密钥）。请先「应用配置」，成功后再来导出。',
    exportStagedAction: '去应用配置',
    exportStagedOffline: '控制通道不可用，暂时无法应用配置',
    downloadConf: '下载配置',
    exportTabConf: '客户端 .conf',
    exportTabScript: '一键安装脚本',
    exportTabUninstall: '一键卸载脚本',
    downloadScript: '下载脚本',
    scriptUsage: '在 peer 机器上以 root 执行（可重复执行）：bash <peer>-install.sh；脚本会安装 wireguard-tools、写入配置、启用并回连验证。',
    scriptUnavailable: '安装脚本暂不可用',
    uninstallUsage: '在 peer 机器上以 root 执行（幂等，可重复）：bash <peer>-uninstall.sh；脚本会停用网卡、删除配置与私钥；默认保留 wireguard-tools 系统包，需要一并卸载时用 KHC_WG_PURGE_TOOLS=1 bash <peer>-uninstall.sh。',
    uninstallUnavailable: '卸载脚本暂不可用',
    rotateTitle: '轮换密钥',
    rotateContext: 'Peer · {name}',
    rotateConfirmTitle: '轮换密钥 {name}？',
    rotateConfirmBody: '会生成新密钥并保持旧密钥有效，直到新设备完成握手并确认。',
    rotationPendingTitle: '等待新设备握手',
    rotationPendingDesc: '旧密钥仍然有效；新设备首次连接后自动切换。',
    rotationCutoverTitle: '已切换到新密钥',
    rotationCutoverDesc: '回滚窗口至 {time}，确认完成后删除旧密钥。',
    rotationExpireHint: '未完成握手最晚 {time} 自动取消',
    rotationExpiredTitle: '换钥已超时取消',
    rotationExpiredDesc: '新设备始终未握手，Agent 已删除新密钥；仓库里仍是新公钥，请恢复旧公钥或重新轮换。',
    rotationRestoreKey: '恢复旧公钥',
    rotationOldKey: '旧公钥',
    rotationNewKey: '新公钥',
    rotationStartedAt: '开始时间',
    rotationGrace: '回滚窗口',
    rotationNewConfig: '新 Peer 配置',
    rotationConfigSaved: '新配置已保存到仓库，导入后等待握手',
    rotationConfigSaveFailed: '新配置保存到仓库失败，请重试',
    rotationNeedSave: '新配置尚未保存到仓库，请取消后重新轮换',
    retrySave: '重试保存',
    confirmDisabledPending: '等待新设备握手后才能确认',
    rotateStartedToast: '换钥已开始，等待新设备握手',
    rotateConfirmedToast: '换钥已完成，旧密钥已删除',
    rotateCanceledToast: '换钥已取消，旧密钥继续使用',
    rotateFailed: '轮换失败',
    confirmFailed: '确认失败',
    cancelFailed: '取消失败',
    deleteTitle: '删除 Peer {name}？',
    deleteBody: '删除后该 Peer 会立即断开，配置随之失效。此操作不可恢复。',
    deleteConfirm: '删除 Peer',
    deletedToast: '已删除 {name}',
    deleteCleanupLabel: '同时清理该 Peer 本机服务',
    deleteCleanupHint:
      '该 Peer 需已在主机运维中 onboard（有 SSH 通道）。将经通道下发清理：WG 服务与配置、Caddy khc.d 配置、转发 unit 与 /opt/khc、/etc/khc 残留。未 onboard 或清理失败、仍有残留时会阻止删除，可取消勾选改为仅删除配置记录。',
    deleteCleanupUnavailable: '该 Peer 未接入运维通道，无法远程清理；直接删除面板记录即可。',
    deleteCleanupRemaining: '清理未完成，已阻止删除。残留项：{items}',
    disabledToast: '已停用 {name}',
    enabledToast: '已启用 {name}',
    rowActions: 'Peer 操作',
    rotateBadgePending: '换钥中',
    rotateBadgeCutover: '已切换',
    rotateBadgeGrace: '回滚期',
    rotateActiveReason: '该 Peer 正在换钥中',
    summaryPeers: '{count} 个 Peer',
    searchPlaceholder: '筛选 Peer',
    publicEndpointMissing: '公网地址未配置',
    publicEndpointMissingDesc: 'Peer 需要可连的公网地址，请在接口设置中填写。',
    invalidExtIface: '出口网卡名称格式不正确',
    forwardsCard: '端口转发',
  },

  apps: {
    summary: '已发布 {installed} 个 · 可安装 {available} 个',
    intro: '安装独立应用；内置模块请在站点、转发、证书等页面配置。',
    notInstalled: '未安装',
    notApplied: '未应用',
    pendingApply: '待生效',
    applied: '已同步',
    empty: '还没有应用',
    emptyHint: '在节点上安装应用后，会显示版本、配置与应用状态。',
    builtinTitle: '内置模块',
    builtinHint: 'WireGuard、站点、转发、证书和主机运维是内置模块，不在这里安装；请到对应页面配置。',
    tabsConfig: '配置',
    tabsChanges: '变更预览',
    tabsTask: '任务',
    tabsHistory: '版本历史',
    configTitle: '配置',
    advanced: '高级',
    saveNote: '保存到仓库后，需应用才会生效',
    applyNote: '应用后相关服务可能短暂重启',
    noSchema: '该应用没有可用配置项，直接编辑 JSON',
    changesEmpty: '还没有变更预览',
    changesEmptyHint: '点击预览变更，查看将要写入节点的文件改动',
    taskEmpty: '还没有任务',
    taskEmptyHint: '安装、应用或卸载时会在这里显示进度',
    historyEmpty: '还没有版本',
    historyEmptyHint: '保存配置后会生成版本记录',
    colVersion: '版本',
    colNote: '说明',
    colTime: '时间',
    colStatus: '状态',
    configVersion: '配置版本',
    appliedVersion: '已应用版本',
    dirty: '有未保存的修改',
    currentVersion: '当前版本 {rev}',
    versionSummary: '配置版本 {config} · 已应用版本 {applied}',
    pendingApplyTitle: '已保存，待应用',
    pendingApplyDesc: '配置已保存到仓库，但尚未下发到节点；节点可达后点击应用即可生效。',
    rollbackTitle: '回滚到版本 {rev}？',
    rollbackBody: '会用旧配置生成一个新版本并应用，当前配置仍保留在版本历史中。',
    rollbackConfirm: '回滚',
    uninstallTitle: '卸载 {app}？',
    uninstallBody: '应用将从节点移除，相关服务停止。此操作不可恢复。',
    uninstallConfirm: '卸载',
    uninstallNameLabel: '输入 {app} 确认',
    installNote: '安装会写入配置文件并启动服务',
    installTitle: '安装 {app}？',
    installBody: '安装会写入配置文件并启动服务，节点上的相关服务可能短暂中断。',
    installConfirm: '安装',
    resultTitle: '执行结果',
    taskTitle: '任务 {id}',
    taskLogsEmpty: '暂无日志',
    planEmpty: '没有文件改动',
    saveToast: '配置已保存',
    applyToast: '配置已应用',
    loadError: '无法加载应用',
    notFound: '应用不存在',
    backToHub: '返回 {name}',
    noAdapters: '节点还没有上报可用应用',
    changesCount: '{count} 个文件',
    applyHint: '保存并生效会用当前表单内容写入节点',
    discardHint: '放弃后恢复为最后一次保存的内容',
    copyDiff: '复制差异',
    runPlan: '预览变更',
    jsonInvalid: 'JSON 格式不合法',
    jsonHint: '直接编辑 JSON，失焦时校验格式',
    configSaved: '配置已保存，可继续应用',
    taskRunning: '任务进行中',
  },

  placeholder: {
    body: '{page}页面将在后续变更单中实现',
    hint: '当前只提供外壳与导航，功能页面尚未接入',
    settings: '设置',
    activityHint: '只显示节点最近操作记录',
    settingsHint: '全局设置会在后续变更单中接入',
    hubSectionHint: '该节点功能会在后续变更单中接入',
  },

  errors: {
    loadTitle: '无法加载{page}',
    loadHint: '请检查控制面连接后重试',
    retry: '重试',
    notFoundTitle: '页面不存在',
    notFoundHint: '这个地址没有对应的页面',
    backHome: '返回概览',
    sessionTitle: '登录已过期',
  },

  log: {
    earlier: '显示更早的 {n} 行',
    latest: '回到最新',
  },

  table: {
    loading: '加载中',
    empty: '暂无数据',
    noMatch: '没有匹配的{object}',
    pageInfo: '{from}–{to} / {total}',
    prevPage: '上一页',
    nextPage: '下一页',
    selected: '已选 {count} 项',
    clearFilter: '清除筛选',
  },

  form: {
    required: '必填',
    invalid: '格式不正确',
    choose: '请选择',
    searchOptions: '搜索选项',
  },

  gallery: {
    title: '组件样例',
    subtitle: 'UI 规范 v2.2 · 组件全状态对照',
    theme: '主题',
    sections: {
      type: '字体与颜色',
      buttons: '按钮',
      status: '状态与徽章',
      surfaces: '卡片与统计',
      table: '表格',
      tabs: '标签页',
      forms: '表单控件',
      secrets: '机密与代码',
      overlays: '浮层',
      feedback: '反馈',
      data: '日志与步骤',
      shell: '外壳',
      layout: '布局与导航',
      action: '动作',
    },
    light: '浅色',
    dark: '深色',
    longName: 'office-router-backup-hongkong-01',
    longDomain: 'very-long-subdomain-for-frontend.console.example.dev',
    sampleTable: '示例表格',
    note: '所有组件只使用 tokens.css 的令牌。',
  },

  toast: {
    hubCreated: '节点已添加',
    configSaved: '配置已保存',
    configSavedPending: '配置已保存，尚未应用——节点可达后请点击应用',
    configApplied: '配置已生效',
  },
  recentOps: {
    title: '最近操作',
    colTime: '时间',
    colActor: '操作者',
    colAction: '操作',
    objectLabel: '操作记录',
    emptyTitle: '暂无操作记录',
    emptyHint: '该节点还没有可显示的运维操作。',
    offlineHint: '节点离线；显示的是控制面已记录的历史操作。',
    errorTitle: '操作记录加载失败',
    errorHint: '稍后重试，或检查控制面连接。',
  },
 } as const;

export type Zh = typeof zh;

/** 简单插值：把模板里的 {name} 替换为变量值。 */
export function fmt(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in vars ? String(vars[key]) : match,
  );
}

